const exerciseOptions =  {
    method: 'GET',
    headers: {
        'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com',

        'X-RapidAPI-Key': '108fd9e93bmshad2fa223ff0ea38p18e86bjsn39dec0d3ee77'
    }
}

export default exerciseOptions